// ====================================================================
// CLIENT FOLLOW-UP CRM - AUTHENTICATION & ROLE MANAGEMENT
// ====================================================================

import { createClient } from '@supabase/supabase-js';
import { SUPABASE_CONFIG } from './config.js';

let supabase = null;
if (SUPABASE_CONFIG.url && SUPABASE_CONFIG.anonKey) {
  try {
    supabase = createClient(SUPABASE_CONFIG.url, SUPABASE_CONFIG.anonKey);
  } catch (err) {}
}

const AUTH_SESSION_KEY = 'crm_auth_user_session';

let currentUser = JSON.parse(localStorage.getItem(AUTH_SESSION_KEY) || 'null');

export function getCurrentUser() {
  return currentUser;
}

export function isAuthenticated() {
  return currentUser !== null;
}

export function isAdmin() {
  return currentUser && currentUser.role === 'admin';
}

export function isStaff() {
  return currentUser && currentUser.role === 'staff';
}

export async function login(email, password) {
  // If Supabase live client configured
  if (supabase) {
    const { data, error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) throw error;

    // Fetch user profile from database
    const { data: profile } = await supabase.from('profiles').select('*').eq('id', data.user.id).single();
    currentUser = {
      id: data.user.id,
      email: data.user.email,
      name: profile ? profile.name : email.split('@')[0],
      role: profile ? profile.role : 'staff'
    };
    localStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(currentUser));
    return currentUser;
  }

  // Local / Demo Mode Login
  const cleanEmail = email.toLowerCase().trim();
  if (cleanEmail.includes('admin')) {
    currentUser = {
      id: 'usr-admin-01',
      name: 'Alex Rivera (Admin)',
      email: 'admin@crm.com',
      role: 'admin'
    };
  } else {
    currentUser = {
      id: 'usr-staff-01',
      name: 'Sarah Chen (Staff)',
      email: 'staff@crm.com',
      role: 'staff'
    };
  }

  localStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(currentUser));
  return currentUser;
}

export async function logout() {
  if (supabase) {
    try { await supabase.auth.signOut(); } catch (e) {}
  }
  currentUser = null;
  localStorage.removeItem(AUTH_SESSION_KEY);
  window.location.hash = '#login';
}

export function demoLogin(role) {
  if (role === 'admin') {
    currentUser = {
      id: 'usr-admin-01',
      name: 'Alex Rivera (Admin)',
      email: 'admin@crm.com',
      role: 'admin'
    };
  } else {
    currentUser = {
      id: 'usr-staff-01',
      name: 'Sarah Chen (Staff)',
      email: 'staff@crm.com',
      role: 'staff'
    };
  }
  localStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(currentUser));
  return currentUser;
}
